import React from 'react';
import classNames from 'classnames';

// @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: a... Remove this comment to see the full error message
function PanelLeft({ children, className = '', rootRef = null, ...otherProps }) {
  const classes = classNames('ws-panel-left', className);

  return (
    <div className={classes} {...otherProps} ref={rootRef}>
      {children}
    </div>
  );
}

export default PanelLeft;
